import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { roPlants } from '../../mock/mockData';

const ROPlant10000LPH = () => {
  const productData = roPlants.find(p => p.id === 'ro-10000');
  return <ProductPageTemplate productData={productData} />;
};

export default ROPlant10000LPH;